// external imports
import { useCallback } from 'react';
import { authenticatedPost } from 'utils/axios';

// project imports
import { ONBOARDING_CREATE } from 'queries/onboarding_create';
import { MerchantOnboarding, MerchantOnboardingInput } from '@trendiolive/trendio-selfcare-ui-kit';

export default function useOnboarding() {
  const onboardingCreate = useCallback(async (onboardingInput: MerchantOnboardingInput): Promise<MerchantOnboarding> => {
    const onboardingCreate = await authenticatedPost({
      query: ONBOARDING_CREATE,
      vars: {
        input: {
          onboardingInput
        }
      }
    });
    return onboardingCreate.data.onboardingCreate.onboarding;
  }, []);

  return {
    onboardingCreate
  };
}
